import { render, staticRenderFns } from "./Sprite.vue?vue&type=template&id=642feaa6&lang=html&"
import script from "./Sprite.vue?vue&type=script&lang=js&"
export * from "./Sprite.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Sprite.vue?vue&type=style&index=0&lang=sass&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "4ca582c2"
  
)

export default component.exports